import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-geboorte',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconGeboorte {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="m30.75 15.97-.9-.13-.3-.84c-1.37-3.86-4.61-6.7-8.51-7.69.04.12.09.22.12.34.3 1.24.1 2.52-.57 3.61a4.742 4.742 0 0 1-2.95 2.15 1.503 1.503 0 0 1-1.81-1.11c-.19-.81.3-1.62 1.11-1.81.95-.23 1.54-1.19 1.31-2.14-.11-.46-.4-.85-.8-1.1-.27-.16-.56-.24-.86-.25-4.81.54-8.85 3.78-10.3 8.41l-.27.85-.89.16c-1.24.23-2.14 1.29-2.14 2.53s.9 2.3 2.14 2.53l.89.16.27.85c1.59 5.08 6.3 8.5 11.71 8.5s10.38-3.67 11.82-8.92l.24-.86.89-.19c1.19-.26 2.06-1.32 2.06-2.51 0-1.26-.96-2.35-2.25-2.54ZM13.43 17.1c.82 0 1.49.66 1.49 1.47s-.67 1.47-1.49 1.47-1.49-.66-1.49-1.47.67-1.47 1.49-1.47m9.94 8.03c-1.63 1.08-3.53 1.65-5.49 1.65s-3.73-.53-5.31-1.53c-.46-.29-.6-.9-.3-1.36.3-.46.92-.58 1.38-.29 2.57 1.63 6.07 1.59 8.61-.09.46-.3 1.08-.18 1.39.26.31.45.19 1.06-.27 1.36Zm-.94-5.14c-.82 0-1.49-.66-1.49-1.47s.67-1.47 1.49-1.47 1.49.66 1.49 1.47-.67 1.47-1.49 1.47"/>
</svg>

    );
  }
}
